import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type NOM_208_SCFI_2016Props = {};

const NOM_208_SCFI_2016: React.FC<NOM_208_SCFI_2016Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='NOM-208-SCFI-2016'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10 pr-10">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                NOM-208-SCFI-2016
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "radio_products",
                    defaultMessage: "Products. Radio communication systems that use the spread spectrum technique Frequency hopping and digital modulation radio communication equipment to operate in the bands 902 MHz-928 MHz, 2400 MHz-2483.5 MHz and 5725 MHz-5850 MHz-Specifications and test methods."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "spread_spectrum_products",
                    defaultMessage: "The products covered by this Official Mexican Standard are all radio communication equipment that uses the spread spectrum technique."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'products_terminal_example',
                    defaultMessage: "Examples of equipment subject to compliance with the NOM:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "wireless_devices",
                    defaultMessage: "Equipment, devices that have some of the following technologies ZigBee, WIFI, Bluetooth"
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full mt-12">
            <img src="/img/wireless-devices.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NOM_208_SCFI_2016;